import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const ReportDownload = createAsyncThunk(
  "report/ReportDownload",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/report/download/`, data)
    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', `invoice.xlsx`);
    document.body.appendChild(link);
    link.click();
  }
); 

export const Report = createAsyncThunk(
  "report/Report",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/report/download/`, data)
    return response.data
  }
); 